import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Phone from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import cx from 'classnames';

const PhoneInput = ({ className, country, value, onChange, label, id, countryCodeEditable }) => {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <div className={className} data-testid="phone-input">
      <div className="phone-input">
        <label
          className={cx('phone-input__phone-label', {
            'phone-input__phone-label--filled': isFocus || !!value || !!country,
          })}
          htmlFor={id}
        >
          {label}
        </label>
        <Phone
          inputProps={{
            id,
            autoComplete: 'off',
            onFocus: () => setIsFocus(true),
            onBlur: () => setIsFocus(false),
            'data-testid': id,
          }}
          placeholder=""
          country={country?.toLowerCase()}
          value={value}
          onChange={onChange}
          countryCodeEditable={countryCodeEditable}
          enableSearch={true}
          containerClass="phone-input__phone"
          inputClass={'phone-input__phone-input'}
          buttonClass="phone-input__phone-button"
          dropdownClass="phone-input__phone-dropdown"
        />
      </div>
    </div>
  );
};

PhoneInput.defaultProps = {
  value: '',
  error: false,
  countryCodeEditable: false,
  country: null,
};

PhoneInput.propTypes = {
  className: PropTypes.string.isRequired,
  country: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  countryCodeEditable: PropTypes.bool,
};
export default PhoneInput;
